<template>
  <el-dialog
    id="create-modal"
    class="form-modal"
    :visible.sync="createVisible"
    v-loading="createProcessing"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
  >
    <div id="create-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">Create Global Music on Hold</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="createOperation">Create</el-button>
          <el-button type="default" @click="cancelOperation">Cancel</el-button>
        </div>
      </div>
    </div>

    <el-form>
      <div class="inline-form-group">
        <el-input v-model="createForm.name" placeholder="Enter name">
          <template slot="prefix">
            <span>Name</span>
          </template>
        </el-input>
      </div>

      <div class="inline-form-group play-order-group">
        <span class="mr-10">Play Order:</span>
        <el-switch
          v-model="createForm.isLinear"
          active-text="In Order"
          inactive-text="Shuffle"
        />
      </div>

      <draggable :key="draggableKey" @change="changeDraggableKey" v-model="mediaKeys">
        <transition-group name="list" tag="div">
          <div
            class="inline-form-group"
            v-for="(item, i) in mediaKeys"
            :key="i + '$(^^)$'"
          >
            <el-col :span="18">
              <el-select
                v-model="item.id"
                filterable
                clearable
                :placeholder="`Select Media File ${i + 1}`"
                style="width: 100%"
              >
                <el-option
                  v-for="m in mediafileOptions"
                  :key="m.id"
                  :label="m.name"
                  :value="m.id"
                />
              </el-select>
            </el-col>
            <el-col :span="1" />
            <el-col :span="5" class="text-right">
              <el-tooltip effect="dark" :content="`Remove Media File ${i + 1}`" placement="top">
                <el-button
                  class="ml-5"
                  style="float: right; margin-right: 1px"
                  @click="removeMediaKey(i)"
                  icon="el-icon-delete"
                />
              </el-tooltip>
              <el-button icon="el-icon-rank" type="default" />
            </el-col>
          </div>
        </transition-group>
      </draggable>

      <div class="inline-form-group">
        <el-button
          type="text"
          icon="el-icon-circle-plus-outline"
          @click="addMediaKey"
        >
          Add Media File
        </el-button>
      </div>

    </el-form>
  </el-dialog>
</template>

<script>
import Draggable from "vuedraggable";
import feathersClient from "@/feathers/feathers-client";

export default {
  name: "GlobalMusicOnHoldsCreateForm",

  props: {
    createVisible: { required: true },
    createProcessing: { required: true },
    clearFormFields: { required: true }
  },

  components: {
    Draggable
  },

  data() {
    return {
      mediafileOptions: [],
      draggableKey: "",
      mediaKeys: [],
      createForm: {
        name: "",
        isLinear: false
      }
    };
  },

  watch: {
    clearFormFields(value) {
      if (value) this.clearFields();
    }
  },

  methods: {
    fetchMediafiles() {
      feathersClient
        .service("mediafiles")
        .find({ query: { tenantId: 0, $sort: { name: 1 } } })
        .then(res => { this.mediafileOptions = res; })
        .catch(() => true);
    },

    changeDraggableKey() {
      const rand = () => Math.random().toString(36).slice(2);
      this.draggableKey = rand() + "-" + rand() + "$" + rand();
    },

    addMediaKey() {
      this.mediaKeys.push({ id: null });
    },

    removeMediaKey(i) {
      this.mediaKeys.splice(i, 1);
    },

    createOperation() {
      const { name, isLinear } = this.createForm;
      this.$emit("createOperation", {
        tenantId: 0,
        name,
        isLinear,
        defaultTenant: false,
        routingDestinations: this.mediaKeys
          .filter(item => item.id !== null)
          .map(item => ({ type: "MEDIAFILE", id: +item.id }))
      });
    },

    cancelOperation() {
      this.$emit("cancelOperation", "create");
    },

    clearFields() {
      this.mediaKeys = [];
      this.draggableKey = "";
      this.createForm = { name: "", isLinear: false };
    }
  },

  created() {
    this.fetchMediafiles();
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/variables";
.play-order-group {
  padding: 8px 0;
}
</style>
